import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
} from '@mui/material';

type OptionType = { value: string, label: string };

interface StatusSelectProps {
  label: string;
  id: string;
  value: string;
  onChange: (event: SelectChangeEvent) => void;
  options: Record<string, string> | OptionType[];
  fullWidth?: boolean;
  size?: 'small' | 'medium';
  disabled?: boolean;
}

const StatusSelect: React.FC<StatusSelectProps> = ({
  label,
  id,
  value,
  onChange,
  options,
  fullWidth = true,
  size = 'small',
  disabled = false,
}) => {
  // optionsが配列かオブジェクトかを判断
  const isOptionsArray = Array.isArray(options);
  
  // オプションの配列を生成
  const optionsArray = isOptionsArray 
    ? options as OptionType[]
    : Object.entries(options as Record<string, string>).map(([value, label]) => ({
        value,
        label
      }));

  return (
    <FormControl fullWidth={fullWidth} size={size} disabled={disabled}>
      <InputLabel id={`${id}-label`}>{label}</InputLabel>
      <Select
        labelId={`${id}-label`}
        id={id}
        value={value}
        onChange={onChange}
        label={label}
      >
        {optionsArray.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default StatusSelect;